import { computed } from "vue"
import { useStore } from "vuex"
import GetLabel from "foundation/js/getLabel"

export default {
    name: "OrdreOverview",
    props: {
        orders: {
            type: Object,
            required: true
        },
    },
    setup(props) {
        const store = useStore()
        
        const results = computed(() => {
            return props.orders
        })

        return {
            results,
            getLabel: (labelKey) => GetLabel({ labelKey, labelCollection: 'OrdreOverview' })
        }

    }
}